import React, { useEffect, useState } from "react";
import { fetch } from "../../actions";
import { connect } from "react-redux";
import { Select } from 'antd';
import { PesqEdit } from "../../components/Selects/SelectPesq";
import { useFetch } from "../../components/Hooks/Conexao";
import { BtnEdit } from "../../components/Buttons";

const { Option } = Select;

function EntregaEnderecoSelect({ value, onChange, clienteId, disableEdit, ...props }) {
    const [enderecos, listarEnderecos, loadingEnderecos, setEnderecos] = useFetch(() => props.fetch().post(`/cliente/getend/${clienteId}`));
    const [clienteEditId, setClienteEditId] = useState(null);

    useEffect(() => {
        if (clienteId)
            listarEnderecos();
        else
            setEnderecos(null);

    }, [clienteId]);

    return <>
        <div style={{ display: "flex", alignItems: "center" }}>
            <Select placeholder="Selecione o endereço de entrega" style={{ width: '100%' }} value={value} onChange={v => onChange(enderecos.find(x => x.id == v))} loading={loadingEnderecos} disabled={disableEdit}>
                {((enderecos || []).map(x => <Option key={x.id} value={x.id}>{`${x.logradouro} - ${x.numero}`}</Option>))}
            </Select>
            {disableEdit ? <></> : !!(enderecos || []).length && <BtnEdit onClick={() => setClienteEditId(clienteId)} style={{ marginLeft: 10 }} />}
        </div>
        <PesqEdit isPk jumpToEnderecos fetch={props.fetch} modelo="cliente" id={clienteEditId} onCancel={() => setClienteEditId(null)} onOk={() => { setClienteEditId(null); listarEnderecos(); }} />
    </>;
}

export default connect(null, { fetch })(EntregaEnderecoSelect);
